<template>
	<div style="width: 100%; height: 85vh; overflow-y: auto; overflow-x: hidden !important">
		<div class="main" :style="{ width: widthscreen }">
			<div class="header">
				<div class="header_title-container title">
					<h1>{{ $t("tickets") }}</h1>
				</div>
				<div class="header_actions">
					<div class="header_actions-container">
						<el-button icon="el-icon-plus" @click="addTicketDialog = true" type="success" plain>
							{{ $t("new-ticket") }}
						</el-button>
						<div style="width: 70%; min-width: 400px; padding-top: 30px">
							<el-input v-model="filters.title" @input="debounceInput" />

							<div v-if="showFilters" style="margin-top: 5px">
								<!-- Status -->
								<el-select
									v-model="filters.status"
									@change="fetchTickets"
									@clear="filters.status = null"
									:placeholder="$t('status')"
									clearable
									filterable
									style="width: 100%"
								>
									<el-option
										v-for="(status, $index) in statusOptions"
										:key="$index"
										:label="$t(`${status}-status-ticket`)"
										:value="status"
									></el-option>
								</el-select>
							</div>
							<div v-if="showFilters" style="margin-top: 5px">
								<!-- Schools -->
								<el-select
									v-if="user && user.organization.id === '1'"
									v-model="filters.organization_id"
									@change="fetchTickets"
									@clear="filters.status = null"
									:placeholder="$t('school')"
									clearable
									filterable
									style="width: 100%"
								>
									<el-option
										v-for="school in schools"
										:key="school.id"
										:label="getSchoolNameFromOrganization(school)"
										:value="school.id"
									></el-option>
								</el-select>
							</div>
							<div v-if="showFilters" style="margin-top: 5px; margin-left: 10px; width: 100%">
								<el-switch
									:active-text="$t('to-read')"
									:inactive-text="$t('all')"
									v-model="filters.hasUnreadMessages"
									@change="fetchTickets"
								/>
							</div>

							<div class="show-filters" @click="collapse">
								{{ showFilters ? $t("hide-filters") : $t("show-filters") }}
								<md-icon>{{ showFilters ? "expand_less" : "expand_more" }}</md-icon>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div>
				<md-table :key="updateID" v-model="tickets">
					<md-table-row
						v-if="item"
						@click="showTicketMessages(true, item.id)"
						slot="md-table-row"
						slot-scope="{ item }"
					>
						<!-- Title -->
						<md-table-cell :md-label="$t('title').toUpperCase()">
							{{ item.title }}
						</md-table-cell>

						<!-- Status -->
						<md-table-cell :md-label="$t('status').toUpperCase()">
							<el-tag :type="statusLabelType(item.status)">
								{{ $t(`${item.status}-status-ticket`) }}
							</el-tag>
						</md-table-cell>

						<!-- School -->
						<md-table-cell v-if="user.organization.id === '1'" :md-label="$t('school').toUpperCase()">
							{{ getSchoolNameFromOrganization(item.organization) }}
						</md-table-cell>

						<!-- Created at -->
						<md-table-cell :md-label="$t('created-at').toUpperCase()">
							{{ new Date(item.created_at).toLocaleString("it-IT", { timezone: "UTC" }) }}
						</md-table-cell>

						<!-- Edit -->
						<!--				<md-table-cell>-->
						<!--					<el-button 	v-if="user && user.organization.id === '1'"-->
						<!--						@click="showEditTicket(true, ticket.id)"-->
						<!--						type="primary"-->
						<!--						icon="el-icon-edit"-->
						<!--						circle-->
						<!--					></el-button>-->
						<!--				</md-table-cell>-->

						<!-- Messages -->
						<md-table-cell :md-label="$t('messages').toUpperCase()">
							{{ item.messages.length }}
							<i
								:class="{
									'el-icon-chat-round': item.messages.length === 0,
									'el-icon-chat-line-round': item.messages.length
								}"
							></i>

							{{ unreadMessagesCount(item.messages) }}
							<i
								:class="{
									'el-icon-bell': unreadMessagesCount(item.messages) === 0,
									'el-icon-message-solid': unreadMessagesCount(item.messages)
								}"
							></i>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<app-pagination :tot="total" :size="pagination.size" :offset="pagination.offset" @fetch="fetchTickets" />

			<add-ticket
				v-if="addTicketDialog"
				:show="addTicketDialog"
				:schools="schools"
				@close="
					opennext => {
						addTicketDialog = false
						if (opennext) {
							focusLastTicket()
						}
					}
				"
			/>
			<edit-ticket
				v-if="editTicketDialog && selectedTicket !== {}"
				:show="editTicketDialog"
				:schools="schools"
				:ticket="selectedTicket"
				@close="showEditTicket(false)"
			/>
			<ticket-messages
				v-if="ticketMessagesDialog && selectedTicket !== {}"
				:forcedid="updateID"
				:show="ticketMessagesDialog"
				:ticket="selectedTicket"
				@close="showTicketMessages(false)"
			/>
		</div>
	</div>
</template>

<script>
import AppPagination from "@/modules/_common/table/app-pagination"
import AddTicket from "@/modules/ticketing/components/modals/add-ticket"
import EditTicket from "@/modules/ticketing/components/modals/edit-ticket"
import TicketMessages from "@/modules/ticketing/components/modals/ticket-messages"
import { getSchoolNameFromOrganization } from "@/utils/utils"
import { mapState, mapActions, mapMutations } from "vuex"
import axios from "axios"
import _ from "lodash"
import { uuid } from "@/modules/builder/utils/utils"

export default {
	name: "ticket-list",
	components: {
		AppPagination,
		AddTicket,
		EditTicket,
		TicketMessages
	},
	data: () => ({
		height: window.innerHeight - 400,
		schools: [],
		addTicketDialog: false,
		editTicketDialog: false,
		ticketMessagesDialog: false,
		selectedTicket: {},
		statusOptions: ["open", "processing", "closed"],
		filters: {
			title: "",
			status: null,
			organization_id: null,
			hasUnreadMessages: null
		},
		widthscreen: window.innerWidth,
		connection: undefined,
		updateID: uuid(),
		showFilters: false
	}),
	computed: {
		...mapState("ticketing", ["tickets", "pagination", "total"]),
		...mapState("user", ["user"])
	},

	watch: {
		"$route.params.id": function (val) {
			this.showTicketMessages(true, val)
		}
	},
	async created() {
		this.getSchools()
		await this.getTickets()
		this.connect()

		if (this.$route.params.id) {
			await this.showTicketMessages(true, this.$route.params.id)
		}
	},
	methods: {
		focusLastTicket() {
			this.$nextTick(() => {
				this.showTicketMessages(true, this.tickets[this.tickets.length - 1].id)
			})
		},
		uuid,
		...mapMutations({
			updateTicketcomm: "ticketing/UPDATE_TICKET"
		}),
		...mapActions("ticketing", ["updateTicket"]),

		updateTick(element) {
			this.updateTicket({ ticketId: element.id, payload: element }).finally(() => {})
		},

		connect() {
			let ws = undefined
			if (process.env.VUE_APP_API_URL.includes("http://"))
				ws = "ws://" + process.env.VUE_APP_API_URL.replace("http://", "") + "/api/ticket/ws"
			else ws = "wss://" + process.env.VUE_APP_API_URL.replace("https://", "") + "/api/ticket/ws"

			this.connection = new WebSocket(ws)

			let auth = false

			this.connection.onmessage = event => {
				if (auth) {
					var data = JSON.parse(event.data)
					var tmp = this.tickets.find(({ id }) => id == data.ticket_id)

					var exist = tmp.messages.findIndex(msg => msg.id == data.id)

					if (exist !== -1) {
						tmp.messages[exist] = data
					} else {
						tmp.messages.push(data)
					}

					this.updateTicketcomm(tmp)
					this.updateID = this.uuid()
				} else {
					if (event.data.includes("bearer")) {
						axios
							.post(
								process.env.VUE_APP_API_URL + "/api/ticket/ws/auth",
								{ token: event.data.replace("bearer ", "") },
								{ headers: { Authorization: "Bearer " + localStorage.getItem("JWT") } }
							)
							.then(res => {
								if (res.data.accepted) {
									auth = true
								} else {
									this.connection.close()
								}
							})
							.catch(err => {
								console.error("errore di autenticazione")
								this.connection.close()
							})
					}
				}
			}

			this.connection.onopen = event => {}
			this.connection.onerror = err => {
				this.connection.close()
			}

			this.connection.onclose = event => {}
		},

		getSchoolNameFromOrganization,
		...mapActions({
			getTickets: "ticketing/getTickets",
			filterTickets: "ticketing/filterTickets",
			doMutate: "ticketing/doMutate"
		}),
		getSchools() {
			if (this.user && this.user.organization.id === "1") {
				axios
					.post(
						`${process.env.VUE_APP_API_URL}/api/organizations/list`,
						{ confirmed: true },
						{ headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` } }
					)
					.then(({ data: { array: schools } }) => (this.schools = schools))
					.catch(console.error)
			}
		},
		debounceInput: _.debounce(function () {
			this.fetchTickets()
		}, 1000),
		fetchTickets(page, size) {
			var f = { ...this.pagination }
			if (size) f.size = size
			if (page) f.offset = (page - 1) * this.pagination.size
			this.doMutate({ element: "pagination", value: f })

			const filters = Object.fromEntries(Object.entries(this.filters).filter(([key, value]) => value))
			this.filterTickets({ ...filters, title: `%${this.filters.title}%`, pagination: f })
		},
		statusLabelType(status) {
			const types = {
				open: "danger",
				processing: "warning",
				closed: "success"
			}

			return types[status] || "info"
		},
		unreadMessagesCount(messages) {
			return (messages || []).filter(({ read, user }) => !read && user && user.id !== this.user.id).length
		},
		showEditTicket(show, ticketId = undefined) {
			this.editTicketDialog = show
			this.selectedTicket = show ? this.tickets.find(({ id }) => id == ticketId) : {}
		},
		showTicketMessages(show, ticketId = undefined) {
			this.selectedTicket = show ? this.tickets.find(({ id }) => id == ticketId) : {}

			if (this.selectedTicket !== {}) {
				this.ticketMessagesDialog = show
			}
		},
		collapse() {
			this.showFilters = !this.showFilters
		}
	}
}
</script>

<style scoped>
.show-filters {
	font-size: small;
	color: grey;
	font-style: italic;
	text-align: right;
	margin-top: 5px;
}
</style>
